import Vue from 'vue';
import FileSaver from 'file-saver';
import format from 'date-fns/format';

export const usersListingService = {
  async retrieveUsers(activeInactive, sortOrder, paginationParameters, searchParam) {
    return Vue.axios
      .get('/users/list', {
        params: {
          activeInactive,
          ...sortOrder,
          ...paginationParameters,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async retrieveRecordCount(activeInactive, searchParam) {
    return Vue.axios
      .get('/users/count-records', {
        params: {
          activeInactive,
          searchParam
        }
      })
      .then(response => response.data);
  },

  async downloadAllUsersXlsx(activeInactive, sortOrder, searchParam) {
    const response = await Vue.axios({
      url: '/users/xlsx',
      method: 'GET',
      params: {
        activeInactive,
        ...sortOrder,
        searchParam
      },
      responseType: 'blob'
    });
    FileSaver.saveAs(response.data, `AllUsers-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
  },

  async downloadCurrentUsersXlsx(activeInactive, sortOrder, paginationParameters, searchParam) {
    const response = await Vue.axios({
      url: '/users/xlsx',
      method: 'GET',
      params: {
        activeInactive,
        ...sortOrder,
        ...paginationParameters,
        searchParam
      },
      responseType: 'blob'
    });

    FileSaver.saveAs(response.data, `AllUsers-${format(new Date(), 'YYYY-MM-DD-HH-mm-ss')}.xlsx`);
  }
};
